import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-facing-decorator";
import QuizCheckableTextQuestion from "@/components/quiz/QuizCheckableTextQuestion.vue";
import { QuizQuestionType } from "@/models/quiz.model";
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
import QuizBlanksQuestion from "@/components/quiz/QuizBlanksQuestion.vue";
import QuizUtils from "@/util/quizUtils";
import QuizPairsMatchingQuestion from "@/components/quiz/QuizPairsMatchingQuestion.vue";
import QuizSortingQuestion from "@/components/quiz/QuizSortingQuestion.vue";
let ExamQuizQuestionsResults = class ExamQuizQuestionsResults extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "questions", void 0);
    _defineProperty(this, "userAnswers", void 0);
  }
  getQuestionLabel(questionId, position) {
    const question = this.getSourceQuestion(questionId);
    if (!question) {
      return '';
    }
    return `${position}/${this.userAnswers.length} - ${question.label}`;
  }
  getCheckableQuestionUserAnswers(questionResult) {
    const answersIds = questionResult?.responsesIds || [];
    if (questionResult.questionType === QuizQuestionType.QUESTION_CHOIX_MULTIPLE) {
      return answersIds;
    }
    return answersIds[0] || null;
  }
  getCheckableQuestionRightAnswers(questionId) {
    const question = this.getSourceQuestion(questionId);
    if (question?.answers?.length) {
      const correctAnswersIds = question.answers.filter(answer => answer.rightAnswer).map(answer => answer.id);
      return question.type === QuizQuestionType.QUESTION_CHOIX_MULTIPLE ? correctAnswersIds : correctAnswersIds[0];
    }
    return null;
  }
  getBlanksQuestionUserAnswers(questionResult) {
    return this.isBlanksQuestion(questionResult) ? questionResult.blanksResponses : [];
  }
  getUserPairsMatching(questionResult) {
    return this.isPairsMatchingQuestion(questionResult) ? questionResult.pairsMatching : [];
  }
  getUserItemsSorting(questionResult) {
    return this.isSortingQuestion(questionResult) ? questionResult.itemsSorting : [];
  }
  getSourceQuestion(questionId) {
    return this.questions.find(q => q.id === questionId);
  }
  isCheckableQuestion(questionResult) {
    return QuizUtils.isCheckableQuestion(questionResult.questionType);
  }
  isBlanksQuestion(questionResult) {
    return QuizUtils.isBlanksQuestion(questionResult.questionType);
  }
  isPairsMatchingQuestion(questionResult) {
    return QuizUtils.isPairsMatchingQuestion(questionResult.questionType);
  }
  isSortingQuestion(questionResult) {
    return QuizUtils.isSortingQuestion(questionResult.questionType);
  }
};
__decorate([Prop({
  required: true
})], ExamQuizQuestionsResults.prototype, "questions", void 0);
__decorate([Prop({
  required: true
})], ExamQuizQuestionsResults.prototype, "userAnswers", void 0);
ExamQuizQuestionsResults = __decorate([Component({
  components: {
    QuizSortingQuestion,
    QuizPairsMatchingQuestion,
    QuizBlanksQuestion,
    QuizReadonlyAlert,
    QuizCheckableTextQuestion
  }
})], ExamQuizQuestionsResults);
export default ExamQuizQuestionsResults;